<template>
    <div class="info-grid-container">
        <div class="grid-item">
            <div class="item-header">
                修理対応
            </div>
            <div class="item-content">
                <div class="triangle"></div>
                <p><span>交換のみ</span></p>
            </div>
        </div>
        <div class="grid-item">
            <div class="item-header">
                本体最大割引
            </div>
            <div class="item-content">
                <div class="double-circle"></div>
                <p><span>最大91%OFF</span></p>
            </div>
        </div>
        <div class="grid-item">
            <div class="item-header">
                対応スピード
            </div>
            <div class="item-content">
                <div class="double-circle"></div>
                <p><span>最短30分で駆けつけ</span></p>
            </div>
        </div>

        <div class="grid-item">
            <div class="item-header">
                保証
            </div>
            <div class="item-content">
                <div class="double-circle"></div>
                <p><span>工事10年<br>商品10年保証</span></p>
            </div>
        </div>
        <div class="grid-item">
            <div class="item-header">
                対応エリア
            </div>
            <div class="item-content">
                <div class="double-circle"></div>
                <p><span>ほぼ全国対応</span></p>
            </div>
        </div>
        <div class="grid-item">
            <div class="item-header">
                キャンペーン
            </div>
            <div class="item-content">
                <div class="double-circle"></div>
                <p><span>Amazonギフト3,000円プレゼント</span></p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InfoGrid',
};
</script>

<style scoped>
.annotation-txt {
    font-size: 10px;
    text-align: left;
    padding: 0;
    padding-left: 20px;
    margin: 0;
    margin-bottom: 5px;
    padding-bottom: 10px;
}

.info-grid-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    padding: 20px;
    padding-bottom: 5px;
    margin-bottom: 20px;
}

.grid-item {
    border: 1px solid #ddd;
    overflow: hidden;
}

.item-header {
    background-color: #5d7ac9;
    color: white;
    font-weight: bold;
    text-align: center;
    padding: 10px 5px;
    font-size: 16px;
}

.item-content {
    background-color: white;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100px;
    padding: 10px;
}

.item-content p {
    padding: 0;
    margin-top: 10px;
    margin-bottom: 0;
}

.content-icon {
    width: 40px;
    height: 40px;
    margin-bottom: 5px;
}

.bold {
    font-weight: bold;
    font-size: 16px;
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 600px) {
    .info-grid-container {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
    }

    .item-header {
        font-size: 1rem;
        padding: 5px;
    }

    .item-content {
        font-size: 0.9rem;
        border: 1px solid gray;
    }

    .annotation-txt {
        font-size: 0.6rem;
        padding-top: 5px;
        padding-bottom: 5px;
    }

    .annotation {
        font-size: 0.6rem;
    }
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 480px) {
    .info-grid-container {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        margin: 0;
        padding: 5px;
        /* gap: 0; */
    }

    .item-header {
        font-size: 0.9rem;
        padding: 5px;
    }

    .item-content {
        font-size: 1rem;
        border: 1px solid gray;
    }

    .annotation-txt {
        font-size: 0.6rem;
        padding-top: 5px;
        padding-bottom: 5px;
    }

    .annotation {
        font-size: 0.6rem;
    }
}
</style>